module.exports = __webpack_public_path__ + "components/tooltips/static/freezing-level-975b341a3c18d8a36971e78e932ecdc1.jpg";